import { alpha, Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  content: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    minWidth: 0,
  },
  section: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  sectionTitle: {
    fontSize: "14px",
    fontWeight: 600,
    fontStyle: "normal",
    lineHeight: "21px",
    letterSpacing: 0,
    color: theme.palette.secondary.main,
    textAlign: "right",
    verticalAlign: "middle",
    width: "100%",
    fontFamily: "Noto Sans Hebrew",
  },
  fieldGrid: {
    display: "grid",
    gap: "10px",
  },
  datesRow: {
    display: "flex",
    flexDirection: "row-reverse",
    gap: "10px",
    alignItems: "flex-end",
    width: "100%",
    direction: "ltr",
    "& $field": {
      flex: 1,
      minWidth: 0,
    },
  },
  field: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    minWidth: 0,
  },
  label: {
    fontSize: "12px",
    color: theme.palette.text.secondary,
    textAlign: "right",
    width: "100%",
    fontFamily: "Noto Sans Hebrew",
  },
  value: {
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: "14px",
    lineHeight: "140%",
    letterSpacing: 0,
    textAlign: "right",
    color: theme.palette.secondary.main,
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: "4px",
    padding: "12px 16px 12px 8px",
    height: "48px",
    width: "100%",
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    opacity: 1,
    direction: "rtl",
    fontFamily: "Noto Sans Hebrew",
  },
  valueSuccess: {
    fontSize: "14px",
    fontWeight: 500,
    color: theme.palette.success.main,
    backgroundColor: alpha(theme.palette.success.main, 0.1),
    border: `1px solid ${alpha(theme.palette.success.main, 0.2)}`,
    borderRadius: "4px",
    padding: "12px 16px 12px 8px",
    height: "48px",
    width: "100%",
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    lineHeight: "20px",
    textAlign: "right",
    opacity: 1,
    direction: "rtl",
    fontFamily: "Noto Sans Hebrew",
  },
  divider: {
    height: "1px",
    backgroundColor: theme.palette.divider,
  },
  saveButton: {
    height: "48px",
    minHeight: "48px",
    borderRadius: "4px",
    padding: "10px 16px",
    gap: "6px",
    textTransform: "none",
    fontSize: "14px",
    fontWeight: 600,
    backgroundColor: theme.palette.primary.main,
    boxShadow: "none",
    boxSizing: "border-box",
    whiteSpace: "nowrap",
    flexShrink: 0,
    fontFamily: "Noto Sans Hebrew",
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      boxShadow: "none",
    },
  },
}));
